module.exports = __webpack_public_path__ + "img/maininfo5.d857fd41.png";